import { authServiceAxiosClient } from '@/lib';
import { withLogger } from '@/utils';

import { globalLetterAPIUrls } from '../data';
import { GlobalLetter } from '../types';

type GlobalLetterResponse = {
  success: boolean;
  message: string;
  data: GlobalLetter;
};

type Return = GlobalLetter;

export type GetGlobalLetter = {
  response: GlobalLetterResponse;
  return: Return;
};

export const getGlobalLetter = withLogger(async (): Promise<Return> => {
  const url = globalLetterAPIUrls.fetch;

  const {
    data: { data },
  } = await authServiceAxiosClient.get<GlobalLetterResponse>(url);

  return data;
});
